import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TEAM } from "@/data/team";

// Compact team preview for the landing page (mirrors the About-page grid,
// but sits inside the home flow after the client marquee).
export default function TeamPreview() {
  return (
    <section className="py-14 md:py-20" data-testid="home-team">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div className="max-w-2xl">
            <div className="text-xs font-mono uppercase tracking-[0.25em] text-primary">Leadership</div>
            <h2 className="mt-2 font-heading font-bold text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              Meet the team behind CloudLab.
            </h2>
            <p className="mt-3 text-muted-foreground max-w-xl leading-relaxed">
              Small enough to move fast, senior enough to make it work.
              Every leader here has shipped products used by hundreds of thousands of people.
            </p>
          </div>
          <Link to="/about#about-team" data-testid="home-team-cta">
            <button className="group rounded-full pl-5 pr-2 py-2 inline-flex items-center gap-3 text-sm font-medium border border-border hover:border-primary/50 hover:text-primary transition-colors">
              <span>Full leadership</span>
              <span className="w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center transition-transform group-hover:translate-x-0.5">
                <ArrowRight className="w-4 h-4" />
              </span>
            </button>
          </Link>
        </div>

        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {TEAM.map((m, i) => (
            <motion.article
              key={m.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              data-testid={`home-team-${m.name.replace(/\s+/g, "-").toLowerCase()}`}
              className="group rounded-3xl border border-border bg-card overflow-hidden hover:border-primary/40 hover:shadow-[0_25px_60px_-20px_hsl(var(--primary)/0.25)] transition-all"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={m.photo}
                  alt={m.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
                />
                <div
                  aria-hidden="true"
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(15,23,42,0) 55%, rgba(15,23,42,0.55) 80%, rgba(15,23,42,0.95) 100%)",
                  }}
                />
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-primary-foreground/80">
                    {m.role}
                  </div>
                  <div className="font-heading font-bold text-lg text-white leading-tight mt-0.5">
                    {m.name}
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
